import { forwardRef, type HTMLAttributes } from "react";

export type BadgeVariant = "neutral" | "info" | "success" | "warning" | "danger";

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant: BadgeVariant;
};

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  neutral: "bg-[var(--fz-badge-neutral-bg)] text-[var(--fz-badge-neutral-text)] border-[var(--fz-badge-neutral-border)]",
  info: "bg-[var(--fz-badge-info-bg)] text-[var(--fz-badge-info-text)] border-[var(--fz-badge-info-border)]",
  success: "bg-[var(--fz-badge-success-bg)] text-[var(--fz-badge-success-text)] border-[var(--fz-badge-success-border)]",
  warning: "bg-[var(--fz-badge-warning-bg)] text-[var(--fz-badge-warning-text)] border-[var(--fz-badge-warning-border)]",
  danger: "bg-[var(--fz-badge-danger-bg)] text-[var(--fz-badge-danger-text)] border-[var(--fz-badge-danger-border)]",
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { children, className = "", variant, ...props },
  ref,
) {
  return (
    <span
      {...props}
      ref={ref}
      data-fz-badge={variant}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold ${VARIANT_CLASSES[variant]} ${className}`}
    >
      {children}
    </span>
  );
});
